// extracted by mini-css-extract-plugin
export default {"researcher":"ResearcherIcon_researcher__RGykv","researcher__G":"ResearcherIcon_researcher__G__9RAo7"};